<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {}
    },

    watch: {

    },

    computed: {

    },

    async mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Номер телефона для переадресации"
            label-for="call_redirect_params_phone_number"
        >
            <b-form-input
                id="call_redirect_params_phone_number"
                v-model="$parent.call_redirect_params.phone_number"
            ></b-form-input>
        </b-form-group>
        <b-form-checkbox v-model="$parent.call_redirect_params.play_notify" name="play_notify" style="margin-top: 5px; margin-bottom: 10px" switch>
            Уведомить об источнике звонка
        </b-form-checkbox>
    </div>
</template>
